import { jsx as i, Fragment as b, jsxs as w } from "react/jsx-runtime";
import { RTECompound as z } from "./components/Compounds/src/RTECompound/RTECompound.js";
import { ImageCompound as M } from "./components/Compounds/src/ImageCompound/ImageCompound.js";
import { getValueListBgColor as f } from "./utils/background-util.js";
import { c as B } from "./hooks-C9VW6Z5w.mjs";
import { BrandIcon as k } from "./components/Compounds/src/BrandIconCompound/src/BrandIcon.js";
import { setTwoColParentClass as D, setTwoColLeftClass as E, setTwoColClass as N, setTwoColRightClass as G, setTwoColClassGrid as H } from "./components/Compounds/src/MultiColumnCompounds/TwoColumnCompound/utils/setCssClasses.js";
import { VideoCompound as j } from "./components/Compounds/src/VideoCompound/VideoCompound.js";
import { Accordion as J } from "./components/Compounds/src/Accordion/src/Accordion.js";
import { LinkCompound as V } from "./components/Compounds/src/LinkCompound/LinkCompound.js";
import { ArticleHeroPillar as q } from "./components/Compounds/src/ArticleHeroPillar/src/ArticleHeroPillar.js";
import { Promo as K } from "./components/Promo/src/Promo.js";
import { AdviceSpotlight as O } from "./components/Compounds/src/AdviceSpotlight/AdviceSpotlight.js";
import { DynamicImageCompound as Q } from "./components/Compounds/src/DynamicImageCompound/DynamicImageCompound.js";
import { ArticleTile as U } from "./components/Compounds/src/ArticleTile/ArticleTile.js";
import { PaginationCompound as X } from "./components/Compounds/src/PaginationCompound/PaginationCompound.js";
import { CalloutCompound as Y } from "./components/Compounds/src/CalloutCompound/CalloutCompound.js";
import { ErrorBoundary as x } from "./components/ErrorBoundary/src/ErrorBoundary.js";
const Z = (r, o) => {
  let e;
  return Array.isArray(r) ? e = r == null ? void 0 : r.map((l, u) => {
    var s;
    const t = (s = r[u + 1]) == null ? void 0 : s.nodeType, n = t == null ? void 0 : t.includes("AccordionCompound");
    return /* @__PURE__ */ i(x, { children: /* @__PURE__ */ i(
      g,
      {
        shouldGrow: !!n,
        brandIconsFullWidth: !0,
        rteFullWidth: !0,
        ...l
      },
      `${o}-${l.identifier}`
    ) }, `${o}-${l.identifier}`);
  }) : e = /* @__PURE__ */ i(g, { ...r }, `${o}`), e;
}, _ = (r, o, e, l) => {
  var t, n, d;
  return /* @__PURE__ */ i(
    "div",
    {
      className: `u-flex u-flexAlignItemsStart ${l ? "content-border u-paddingHoriz16" : ""} ${e}`,
      children: r ? /* @__PURE__ */ i(x, { children: /* @__PURE__ */ i(
        g,
        {
          ...r,
          brandIconsFullWidth: !0,
          shouldGrow: ((t = r.nodeType) == null ? void 0 : t.includes("RTEcompound")) || ((n = r.nodeType) == null ? void 0 : n.includes("ImageCompound")) || ((d = r.nodeType) == null ? void 0 : d.includes("AccordionCompound"))
        },
        `${o}-${r.identifier}`
      ) }, `${o}-${r.identifier}`) : null
    },
    `${o}-${(r == null ? void 0 : r.identifier) ?? ""}`
  );
}, T = (r, o, e, l, u) => {
  const t = [];
  return r === 0 && (t.push("u-paddingTop24"), o ? t.push("show-top--backgroundColor") : t.push("show-top")), r !== 0 && (t.push("u-paddingTop8"), t.push("u-borderTop0")), r !== e - 1 && t.push("u-borderBottom0"), r === e - 1 && (t.push("show-bottom"), t.push("u-paddingBottom24")), l && t.push(u), o && t.push(o), t.join(" ");
}, L = (r, o, e, l) => {
  const u = [], t = Math.max(...r.map((n) => n.length));
  for (let n = 0; n < t; n++)
    r.forEach((d, s) => {
      const a = T(
        n,
        o[s],
        t,
        s !== r.length - 1,
        l
      );
      u.push(_(d[n], `${s}${n}`, a, e));
    });
  return u;
}, A = (r, o, e, l) => r.map((u, t) => {
  const n = o[t], d = Z(u, String(t)), s = l[t];
  return /* @__PURE__ */ i(
    "div",
    {
      className: `Chip-group u-flexCol ${s ? " u-sm-flexRow" : ""} u-flexNoWrap u-flexAlignItemsStart u-sm-sizeFull u-sm-paddingVert8 u-sm-paddingRight8 ${t % 2 === 0 ? "u-sm-paddingLeft0" : "u-sm-marginBottom16"}`,
      children: e || n ? /* @__PURE__ */ i(
        "div",
        {
          className: `${e ? "content-border" : ""} u-flexCol u-flex u-flexJustifyStart u-flexAlignItemsStart u-sizeFull u-paddingBottom20 u-paddingTop24 u-sm-paddingHoriz8 ${n}`,
          children: d
        }
      ) : /* @__PURE__ */ i(b, { children: d })
    },
    `mobile-column-${t}`
  );
}), y = (r) => {
  const {
    title: o,
    leftColumnList: e,
    middleColumnList: l,
    rightColumnList: u,
    hasBorder: t,
    hasDivider: n,
    collapseRows: d,
    leftColumnColor: s,
    middleColumnColor: a,
    rightColumnColor: c
  } = r, C = B() || d;
  if (!e)
    return null;
  const h = !!(t && t === "true"), p = [
    s ? f(s) : "",
    a ? f(a) : "",
    c ? f(c) : ""
  ];
  return /* @__PURE__ */ w(b, { children: [
    o && /* @__PURE__ */ i("h2", { className: "u-paddingBottom20", children: o }),
    /* @__PURE__ */ i("div", { className: "ThreeColumnWrapper u-flexNoWrap u-sm-flex u-sm-flexCol", children: C ? A(
      [e ?? [], l ?? [], u ?? []],
      p,
      h,
      []
    ) : L(
      [e ?? [], l ?? [], u ?? []],
      p,
      h,
      n && n === "true" ? "u-lg-borderRight u-md-borderRight u-paddingRight16" : ""
    ) })
  ] });
}, oo = (r) => {
  const {
    title: o,
    firstColumnList: e,
    secondColumnList: l,
    thirdColumnList: u,
    fourthColumnList: t,
    hasBorder: n,
    hasDivider: d,
    collapseRows: s,
    firstColumnColor: a,
    secondColumnColor: c,
    thirdColumnColor: C,
    fourthColumnColor: h
  } = r, p = B() || s === "true";
  if (!e)
    return null;
  const m = n === "true", R = [
    a ? f(a) : "",
    c ? f(c) : "",
    C ? f(C) : "",
    h ? f(h) : ""
  ];
  return /* @__PURE__ */ w(b, { children: [
    o && /* @__PURE__ */ i("h2", { className: "u-paddingBottom20", children: o }),
    /* @__PURE__ */ i("div", { className: "FourColumnWrapper u-sm-flex u-sm-flexCol", children: p ? A(
      [
        e ?? [],
        l ?? [],
        u ?? [],
        t ?? []
      ],
      R,
      m,
      []
    ) : L(
      [
        e ?? [],
        l ?? [],
        u ?? [],
        t ?? []
      ],
      R,
      m,
      d && d === "true" ? "u-lg-borderRight u-md-borderRight u-paddingRight16" : ""
    ) })
  ] });
}, ro = (r) => {
  const { leftColumnList: o, rightColumnList: e, columnSize: l, ratio: u, template: t } = r;
  let n, d;
  return Array.isArray(o) ? n = o == null ? void 0 : o.map((s) => /* @__PURE__ */ i(
    g,
    {
      template: t,
      columnSize: l,
      ...s
    },
    `left-content-${s.identifier}`
  )) : n = /* @__PURE__ */ i(
    g,
    {
      template: t,
      columnSize: l,
      ...o
    },
    "left-content"
  ), Array.isArray(e) ? d = e == null ? void 0 : e.map((s) => /* @__PURE__ */ i(
    g,
    {
      template: t,
      columnSize: l,
      ...s
    },
    `right-content-${s.identifier}`
  )) : d = /* @__PURE__ */ i(
    g,
    {
      template: t,
      columnSize: l,
      ...e
    },
    "right-content"
  ), /* @__PURE__ */ w("div", { className: `${D(u, l)}`, children: [
    /* @__PURE__ */ i("div", { className: `${E(u, l)} ${N("left", u)}`, children: l && l === "customConstrainedLeft" ? /* @__PURE__ */ i("div", { className: "u-paddingLeft20 u-sm-paddingLeft0 u-md-paddingLeft0 u-paddingRight32 u-sm-paddingRight0 u-md-paddingRight0", children: n }) : /* @__PURE__ */ i(b, { children: n }) }),
    /* @__PURE__ */ i("div", { className: `${G(u)} ${N("right", u)}`, children: l && l === "customConstrainedRight" ? /* @__PURE__ */ i("div", { "data-testid": "customConstrainedRight-wrapper", children: d }) : /* @__PURE__ */ i(b, { children: d }) })
  ] });
}, F = (r) => {
  const {
    leftColumnList: o,
    rightColumnList: e,
    hasBorder: l,
    ratio: u,
    hasDivider: t,
    collapseRows: n,
    leftColumnColor: d,
    rightColumnColor: s,
    leftColumnContentRow: a,
    rightColumnContentRow: c,
    contentReverse: C
  } = r, h = B() || n, p = !!(l && l === "true"), m = [
    d ? f(d) : "",
    s ? f(s) : ""
  ], R = t && t === "true" ? "u-lg-borderRight u-md-borderRight u-paddingRight16" : "", $ = !!(a && a === "true"), v = !!(c && c === "true"), P = !!(C && C === "true"), I = [$, v];
  return /* @__PURE__ */ i(
    "div",
    {
      className: `TwoColumnWrapper ${H(u)} u-sm-flex ${P ? "u-sm-flexColReverse" : "u-sm-flexCol"} `,
      children: h ? A(
        [o ?? [], e ?? []],
        m,
        p,
        I
      ) : L(
        [o ?? [], e ?? []],
        m,
        p,
        R
      )
    }
  );
}, to = (r) => {
  const { title: o, template: e, content: l } = r;
  return /* @__PURE__ */ w(b, { children: [
    o && /* @__PURE__ */ i("h2", { className: "u-marginTop20 u-marginBottom16", children: o }),
    e ? ((t) => t === "Microsite" ? /* @__PURE__ */ i(ro, { template: e, ...l }) : /* @__PURE__ */ i(F, { ...l }))(e) : /* @__PURE__ */ i(F, { ...l })
  ] });
}, g = (r) => {
  const {
    nodeType: o,
    rteCompoundProps: e,
    imageCompoundProps: l,
    threeColumnCompoundProps: u,
    fourColumnCompoundProps: t,
    brandIconCompoundProps: n,
    twoColumnCompoundProps: d,
    videoCompoundProps: s,
    accordionCompoundProps: a,
    linkCompoundProps: c,
    articleHeroPillarCompoundProps: C,
    promoCompoundProps: h,
    adviceSpotlightProps: p,
    shouldGrow: m,
    dynamicImageCompoundProps: R,
    brandIconsFullWidth: $,
    rteFullWidth: v,
    articleTileProps: P,
    paginationCompoundProps: I,
    calloutCompoundProps: S,
    columnSize: W
  } = r;
  return o != null && o.includes("DynamicImageCompound") ? /* @__PURE__ */ i(
    Q,
    {
      template: r == null ? void 0 : r.template,
      ...R,
      shouldGrow: m
    }
  ) : o != null && o.includes("ImageCompound") ? /* @__PURE__ */ i(M, { ...l, shouldGrow: m }) : o != null && o.includes("RTEcompound") ? /* @__PURE__ */ i(z, { shouldGrow: m, fullWidth: v, ...e }) : o != null && o.includes("ThreeColumnCompound") ? /* @__PURE__ */ i(y, { ...u }) : o != null && o.includes("FourColumnCompound") ? /* @__PURE__ */ i(oo, { ...t }) : o != null && o.includes("BrandIcon") ? /* @__PURE__ */ i(
    k,
    {
      ...n,
      shouldGrow: m,
      brandIconsFullWidth: $
    }
  ) : o != null && o.includes("TwoColumnCompound") ? /* @__PURE__ */ i(to, { ...d }) : o != null && o.includes("AccordionCompound") ? /* @__PURE__ */ i(J, { ...a, shouldGrow: m }) : o != null && o.includes("VideoCompound") ? /* @__PURE__ */ i(j, { ...s, shouldGrow: m }) : o != null && o.includes("LinkCompound") ? /* @__PURE__ */ i(
    V,
    {
      ...c,
      shouldGrow: m,
      template: r == null ? void 0 : r.template,
      columnSize: W
    }
  ) : o != null && o.includes("ArticleHeroPillarCompound") ? /* @__PURE__ */ i(q, { ...C, shouldGrow: m }) : o != null && o.includes("PromoCompound") ? /* @__PURE__ */ i(K, { ...h, shouldGrow: m }) : o != null && o.includes("AdviceSpotlightCompound") ? /* @__PURE__ */ i(O, { ...p, shouldGrow: m }) : o != null && o.includes("ArticleTileCompound") ? /* @__PURE__ */ i(U, { ...P }) : o != null && o.includes("PaginationCompound") ? /* @__PURE__ */ i(X, { ...I }) : o != null && o.includes("CalloutCompound") ? /* @__PURE__ */ i(Y, { ...S }) : "No compound found";
};
export {
  g as C,
  F as D,
  oo as F,
  ro as M,
  to as T,
  y as a,
  A as b,
  L as o
};
//# sourceMappingURL=Compounds-BIU3W9fa.mjs.map
